module.exports = __webpack_public_path__ + "static/img/img_over1.029777a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_over1.png
// module id = cZh9
// module chunks = 1